/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatchedProviderOnboarding } from '../models/PatchedProviderOnboarding';
import type { ProviderOnboarding } from '../models/ProviderOnboarding';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OnboardingProviderService {

    /**
     * @returns ProviderOnboarding
     * @throws ApiError
     */
    public static onboardingProviderRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
    }): CancelablePromise<ProviderOnboarding> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/onboarding-provider/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderOnboarding
     * @throws ApiError
     */
    public static onboardingProviderUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        requestBody: ProviderOnboarding,
    }): CancelablePromise<ProviderOnboarding> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/onboarding-provider/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderOnboarding
     * @throws ApiError
     */
    public static onboardingProviderPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        requestBody?: PatchedProviderOnboarding,
    }): CancelablePromise<ProviderOnboarding> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/onboarding-provider/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderOnboarding
     * @throws ApiError
     */
    public static onboardingProviderMarketplaceAgreementRetrieve({
        id,
        xTz,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        /**
         * The timezone of the user making the request
         */
        xTz: string,
    }): CancelablePromise<ProviderOnboarding> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/onboarding-provider/{id}/marketplace_agreement/',
            path: {
                'id': id,
            },
            headers: {
                'x-tz': xTz,
            },
        });
    }

    /**
     * @returns ProviderOnboarding
     * @throws ApiError
     */
    public static onboardingProviderMarketplaceAgreementCreate({
        id,
        xTz,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        /**
         * The timezone of the user making the request
         */
        xTz: string,
        requestBody: ProviderOnboarding,
    }): CancelablePromise<ProviderOnboarding> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding-provider/{id}/marketplace_agreement/',
            path: {
                'id': id,
            },
            headers: {
                'x-tz': xTz,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
